import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './PaymentAlert.style';

export default function PaymentAlert() {
  return (
    <Styled.AlertContainer>
      <Stack gap={0.5}>
        <Text size="sm" weight="bold" color="red">
          <FormattedMessage id="dashboard.paymentReturn.alert.title" />
        </Text>
        <Text size="sm" color="red">
          <FormattedMessage id="dashboard.paymentReturn.alert.message" />
        </Text>
      </Stack>
    </Styled.AlertContainer>
  );
}
